var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuestionbankMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_questionbank_mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9898\\u5E93-\\u5355\\u9009\\u9898",
    transform: "translate(-1268, -254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_questionbank_mark",
    transform: "translate(1266, 252)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75939418,4.42919263 C6.03037233,2.81244098 8.05246699,2.21956515 8.05246699,2.21956515 C10.7069266,1.24808716 12.0453171,3.8151347 12.0453171,3.8151347 C14.3540184,7.30951227 16.852898,6.98531466 16.852898,6.98531466 C19.8564641,7.15410255 21.3848096,5.68607154 21.3848096,5.68607154 L21.4638274,5.64504516 C22.1640493,5.37413725 21.9774425,5.90926398 21.9774425,6.29009584 C21.9464158,6.55988891 21.9464158,7.06959712 21.5071309,7.91576627 C21.0678459,8.76193542 20.827891,9.46362035 19.7852589,10.8825981 C18.7426268,12.3015758 18.6636091,12.6503 17.0006656,14.0472038 C15.337722,15.4441075 13.5937519,13.7718365 13.5937519,13.7718365 C12.8379497,13.0567734 12.0053618,12.7568795 12.0053618,12.7568795 C9.89442804,12.1871925 7.73572648,13.8761862 6.92211184,14.6102017 L8.62724277,20.5706216 C8.80335853,21.1581462 8.46943055,21.7768865 7.88126194,21.9530324 C7.29309333,22.1289553 6.67367477,21.795393 6.49755901,21.2078684 C6.49488045,21.1987267 6.49220188,21.1895849 6.48974653,21.1802202 L2.04310255,5.63501153 C1.87435285,5.04548025 2.21609332,4.43075341 2.80627086,4.26218849 C3.13301282,4.16885802 3.48454439,4.22996986 3.76051025,4.42807778 L3.75939418,4.42919263 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#999999",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionbankMark);
export default __webpack_public_path__ + "static/media/icon_questionbank_mark.svg";
export { ForwardRef as ReactComponent };